import { memo, useContext, useMemo } from 'react';

import { useLanguage } from 'assets/languages';
import CampaignFormFieldGroup from '../../../../../campaignFormFieldGroup/campaignFormFieldGroup';
import NeedGuidelineRuleField from '../needGuidelineRuleField/needGuidelineRuleField';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import { useWatch } from 'react-hook-form';
import { GUIDELINE_RULE_DTO_ENUMS } from 'api/repositories/guidelineRules/guidelineRules.constants';

const PartnershipAdvertisementCodeFieldGroup = () => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.campaigns };
  const { guidelineRuleFormMethods } = useContext(CampaignFormContext);

  const requirePartnershipCodeValue = useWatch({
    control: guidelineRuleFormMethods.control,
    name: 'REQUIRE_PARTNERSHIP_CODE.value',
  });

  const isRequiredPartnershipCode = useMemo(() => {
    return (
      requirePartnershipCodeValue ===
      GUIDELINE_RULE_DTO_ENUMS.REQUIRE_PARTNERSHIP_CODE_OPTIONS.REQUIRED
    );
  }, [requirePartnershipCodeValue]);

  const onChangeRequirePartnershipCode = (value: boolean) => {
    guidelineRuleFormMethods.setValue(
      'REQUIRE_PARTNERSHIP_CODE.value',
      value
        ? GUIDELINE_RULE_DTO_ENUMS.REQUIRE_PARTNERSHIP_CODE_OPTIONS.REQUIRED
        : null,
    );
  };

  return (
    <CampaignFormFieldGroup
      wrapperClassName="!gap-[30px]"
      label={`8. ${languageTexts.campaign_form_partnership_code_field_label}`}
    >
      <div className="flex flex-col gap-[35px]">
        <div className="flex flex-col gap-[10px]">
          <NeedGuidelineRuleField
            label={languageTexts.campaign_form_partnership_code_field_label}
            checked={isRequiredPartnershipCode}
            onClick={onChangeRequirePartnershipCode}
          />

          {isRequiredPartnershipCode && (
            <p className="text-[14px] text-[#999999]">
              {
                languageTexts.campaign_form_partnership_code_field_required_description
              }
            </p>
          )}
        </div>
      </div>
    </CampaignFormFieldGroup>
  );
};

export default memo(PartnershipAdvertisementCodeFieldGroup);
